import clsx from 'clsx';
import React from 'react';

import TooltipWrapper from '@components/pages/AI/DeepResearch/Chatbot/Controls/TooltipWrapper';
import { useAppContext } from '@contexts/AppContext';
import useNativeAppVersionCheck from '@hooks/useNativeAppVersionCheck';
import { ContentType } from '@tracking';

import BookmarkButton from './BookmarkButton';
import { BookmarkSize } from './constants';
import useBookmarkToggle from './useBookmarkToggle';

interface BookmarkProps {
  contentId: number;
  contentType: ContentType;
  size?: BookmarkSize;
}

const Bookmark = ({ contentId, contentType, size = BookmarkSize.Large }: BookmarkProps) => {
  const { isApp3_0OrGreater, isNativeApp } = useNativeAppVersionCheck();
  const { initialCurrentUser, showBookmarksFlagEnabled } = useAppContext();
  const showBookmark =
    initialCurrentUser?.is_subscriber &&
    ((isNativeApp && isApp3_0OrGreater) || showBookmarksFlagEnabled);
  const { hydrated, isBookmarked, isDisabled, tooltipMessage, handleBookmarkClick } =
    useBookmarkToggle(contentType, contentId, showBookmark);

  if (!showBookmark) {
    return null;
  }

  const button = (
    <BookmarkButton
      isBookmarked={isBookmarked}
      isDisabled={isDisabled}
      onClick={handleBookmarkClick}
      size={size}
      tooltipMessage={tooltipMessage}
    />
  );

  return !hydrated ? (
    button
  ) : (
    <TooltipWrapper tooltipMessage={tooltipMessage} tooltipPlacement="top">
      <div className={clsx({ 'pointer-events-none': isDisabled, 'cursor-pointer': !isDisabled })}>
        {button}
      </div>
    </TooltipWrapper>
  );
};

export default Bookmark;
